<template>
  <div class="block container">
    <div class="flex-item attention-state">
      <span v-if="attention.status == 'PENDING'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_pendiente_v2.svg"
          alt="pendiente"
        />
      </span>
      <span v-if="attention.status == 'COMPLETED'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_check_v2.svg"
          alt="completado"
        />
        <img
          v-if="attention.participationOf.evaluation == 'MEH'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon02.svg"
          alt="Evaluación de participación"
        />
        <img
          v-if="attention.participationOf.evaluation == 'YAY'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon01.svg"
          alt="Evaluación de participación"
        />
        <img
          v-if="attention.participationOf.evaluation == 'SAD'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon03.svg"
          alt="Evaluación de participación"
        />
      </span>
      <span v-if="attention.status == 'FAILED'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_nocheck_v2.svg"
          alt="fallido"
        />
        <img
          v-if="attention.participationOf.evaluation == 'MEH'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon02.svg"
          alt="Evaluación de participación"
        />
        <img
          v-if="attention.participationOf.evaluation == 'YAY'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon01.svg"
          alt="Evaluación de participación"
        />
        <img
          v-if="attention.participationOf.evaluation == 'SAD'"
          class="icon icon-svg attention-state-item attention-evaluation"
          src="@/static/svg/emoticon03.svg"
          alt="Evaluación de participación"
        />
      </span>
    </div>
    <div class="flex-item" style="width: 91%;">
      <div class="meta-list">
        <div class="meta-item date">
          <span class="meta-value">{{ attention.dueBy | formatStandardDate }}</span>
        </div>

        <div class="meta-name" style="margin-bottom: 3px;">
          <span class="meta-value">
            <strong>{{ attention.responsible.name }}</strong>
          </span>
        </div>

        <div v-if="attention.status !== 'PENDING'">
          <div
            v-if="attention.participationOf && attention.participationOf['comment']"
            class="meta-item comment"
          >
            <span class="meta-value">{{ attention.participationOf["comment"] }}</span>
          </div>
          <div v-else class="comment">
            <span class="meta-value">Sin Comentario</span>
          </div>
        </div>

        <div class="meta-item registerBy">
          <span>
            Registrado: {{ attention.createdAt | formatStandardDate }},
            {{ attention.creator.name }}
          </span>
        </div>

        <div
          style="margin-bottom: 10px;"
          v-if="attention.status !== 'PENDING' && attention.finishedBy"
        >
          <div v-if="attention.finishedBy">
            <span v-if="attention.finishedBy" class="meta-item finish-reponsible"
              >Responsable: {{ attention.finishedBy.name }}</span
            >
            <span v-else class="meta-item finish-reponsible">Sin responsable de cierre</span>
          </div>
        </div>
        <div style="margin-bottom: 10px;" v-else></div>

        <div v-if="!attention.isDone" class="actions">
          <a
            class="button is-primary"
            style="margin-bottom: 10px; text-decoration: none;"
            href="#"
            @click.prevent="finishAttention(attention.id)"
            >Finalizar</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"

export default {
  props: {
    attention: {
      type: Object
    },
    creator: {
      type: String
    }
  },

  methods: {
    finishAttention(attentionId) {
      this.$emit("finish-attention", attentionId)
    },
    attentionEvaluationImage(participation) {
      if (participation.evaluation === "MEH") {
        return "@/static/svg/emoticon02.svg"
      } else if (participation.evaluation === "YAY") {
        return "@/static/svg/emoticon01.svg"
      } else if (participation.evaluation === "SAD") {
        return "@/static/svg/emoticon03.svg"
      }
    }
  },

  filters: {
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date)
          .format("DD/MM/YYYY")
          .replace(/[/]/g, ".")
      }
    }
  }
}
</script>

<style scoped>
.block {
  background: white;
}

.container {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.attention-state {
  width: 9%;
  font-size: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.attention-state-item {
  display: flex;
  justify-content: center;
}

.attention-evaluation {
  margin-top: 10px;
}

.meta-list {
  margin-bottom: 0;
}

.meta-item {
  margin-bottom: 10px;
  color: gray;
}

.meta-value {
  color: black;
}

.comment {
  margin-bottom: 15px !important;
}

.finish-reponsible {
  font-size: 13px;
  margin-bottom: 10px;
}

.registerBy {
  font-size: 13px;
  margin-bottom: 0 !important;
}

.date {
  margin-bottom: 10px !important;
}
</style>
